module.exports = __webpack_public_path__ + "static/reverseMortgagebg-2bf2ee9fc5efb12caa3501f92efa7021.jpg";